import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
    };
}
const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
    productsDataView: getProductListDataView(state),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps> & WidgetProps;

export interface NISProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    mobileFilterGridItem?: GridItemProps;
    hiddenMobileFilterStyles?: HiddenProps;
    searchkeyWordFilters?: GridItemProps;
    hiddenSearchKeywordStyles?: HiddenProps;
}

export const controlsContainerStyles: NISProductListControlsContainerStyles = {
    container: {
        gap: 0,
        css: css`
            padding-top: 0px;
            > div {
                background: ${getColor("primary.contrast")};
                padding-top: 0px;
                gap: 24px;
                justify-content: space-between;
                align-items: center;
                @media (min-width: 768px) and (max-width: 991px) {
                    flex-wrap: wrap;
                    height: 130px;
                }
              
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                        `,
                        css`
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                        `,
                        css`
                            flex-direction: row;
                            gap: 16px;
                            padding-top: 0px;
                            // padding-bottom: 20px;
                            justify-content: space-around;
                        `,
                        css`
                            padding-left: 0px;
                            @media (min-width: 992px) and (max-width: 1280px) {
                                padding-left: 0px !important;
                            }
                        `,
                        css`
                            padding-left: 0px;
                        `,
                    ])}
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-top: 0px;
                    `,
                    css`
                        padding-top: 0px;
                    `,
                    css`
                        padding-top: 0px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    countGridItem: {
        width: [12, 12, 5, 0, 0],
        css: css`
            order: 0;
            @media (min-width: 768px) and (max-width: 991px) {
                flex-basis: 50% !important;
                max-width: 50% !important;
            }
            @media (min-width: 992px) and (max-width: 1280px) {
                flex-basis: 13.666667% !important;
                max-width: 13.666667% !important;
            }
            @media (min-width: 991px) {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: auto;
                        max-width: 100%;
                    `,
                    css`
                        // flex-basis: 40% !important;
                        // max-width: 40% !important;
                        flex-basis: auto;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 16.666667%;
                        max-width: 16.666667%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    countTableViewGridItem: {
        width: [12, 12, 1, 1, 1],
        css: css``,
    },
    searchkeyWordFilters: {
        width: [0, 12, 3, 7, 7],
        css: css`
            order: 2;
            flex-basis: 58% !important;
            max-width: 58% !important;
            @media (min-width: 768px) and (max-width: 991px) {
                flex-basis: 76.666667% !important;
                max-width: 76.666667% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        padding-left: 0px;
                    `,
                    null,
                    null,
                ])}
            // @media (min-width: 1200px) and (max-width: 1280px) {
            //     flex-basis: 50.666667% !important;
            //     max-width: 50.666667% !important;
            // }

            @media (min-width: 992px) and (max-width: 1199px) {
                flex-basis: 44.666667% !important;
                max-width: 44.666667% !important;
            }
        `,
    },
    sortGridItem: {
        width: [12, 12, 5, 2, 2],
        css: css`
            order: 3;
            max-width: 23.58% !important;
            flex-basis: 23.58% !important;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 1;
            }

            @media (min-width: 992px) and (max-width: 1199px) {
                flex-basis: 28.666667% !important;
                max-width: 28.666667% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        margin-right: 10px;
                    `,
                    null,
                ])}
        `,
    },
    sortTableViewGridItem: {
        width: [12, 12, 5, 4, 3],
    },
    filterGridItem: {
        width: 0,
        css: css``,
    },
    filterTableViewGridItem: {
        width: [0, 0, 2, 2, 2],
    },
    viewSelectGridItem: {
        width: [0, 0, 3, 1, 1],
        css: css`
            order: 4;
            flex-basis: 12.22% !important;
            max-width: 12.22% !important;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 3;
                flex-basis: 20% !important;
                max-width: 20% !important;
            }

            @media (min-width: 992px) and (max-width: 1199px) {
                flex-basis: 18.666% !important;
                max-width: 18.6666% !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css`
                        @media (min-width: 992px) and (max-width: 1280px) {
                            flex-basis: 13.666% !important;
                            max-width: 13.6666% !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    viewSelectTableViewGridItem: {
        width: [0, 0, 5, 2, 1],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    mobileFilterGridItem: {
        width: [12, 12, 12, 0, 0],
    },
    hiddenMobileFilterStyles: {
        css: css`
            order: 1;
            align-self: flex-end;
            margin-right: 0px;
            @media (min-width: 768px) and (max-width: 991px) {
                order: 1;
                margin-right: 0;
                width: 47%;
                text-align: right;
                align-self: flex-start;
            }
        `,
    },
    hiddenSearchKeywordStyles: {
        css: css``,
    },
};

const styles = controlsContainerStyles;

const NISProductListControlsContainer: FC<Props> = ({ id, view, productsDataView, fields }) => {
    return productsDataView.value?.length === 0 ? null : (
        <GridContainer {...styles.container}>
            <GridItem {...(view === "Table" ? styles.countTableViewGridItem : styles.countGridItem)}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>

            <GridItem {...styles.searchkeyWordFilters}>
                <Zone contentId={id} zoneName="Content05" />
            </GridItem>

            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>

            <GridItem {...(view === "Table" ? styles.filterTableViewGridItem : styles.filterGridItem)}>
                <Zone contentId={id} zoneName="Content02" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.viewSelectTableViewGridItem : styles.viewSelectGridItem)}>
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
            <Hidden above="md" {...styles.hiddenMobileFilterStyles}>
                <GridItem {...styles.mobileFilterGridItem}>
                    <Zone contentId={id} zoneName="ContentMobileFilter" />
                </GridItem>
            </Hidden>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(NISProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "NIS List Controls Container",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "TextField",
                defaultValue: "linear-gradient(90deg,#266b40 27.08%,#2d804c 71.87%,#43687a 100%)",
                fieldType: "General",
                displayName: "Background Color",
            },
        ],
    },
};

export default widgetModule;
